import { ActionType, createAction } from 'typesafe-actions';
import { Organization } from '../../../types/organization';
import { SetOrganizationFont } from './types';

export const fetchOrganizationFulfilled = createAction(
  'FETCH_ORGANIZATION_FULFILLED',
  (payload: Organization) => payload
)<Organization>();

export const updateOrganization = createAction(
  'UPDATE_ORGANIZATION',
  (payload: Organization) => payload
)<Organization>();

export const updateOrganizationFulfilled = createAction(
  'UPDATE_ORGANIZATION_FULFILLED',
  (payload: Organization) => payload
)<Organization>();

export const setOrganizationFont = createAction(
  'SET_ORGANIZATION_FONT',
  (font: string) => ({
    font,
  })
)<SetOrganizationFont>();

export type OrganizationActions = ActionType<
  | typeof fetchOrganizationFulfilled
  | typeof updateOrganization
  | typeof updateOrganizationFulfilled
  | typeof setOrganizationFont
>;
